import PropTypes from 'prop-types';

export default PropTypes.shape({
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
    state: PropTypes.object
  }),
  listen: PropTypes.func,
  push: PropTypes.func
});
